export class AmountPerUnit {
  amount?: number;
  currency?: string;
  unit?: string;

  constructor(currency?: string, amount?: number, unit?: string) {
    this.amount = amount;
    this.currency = currency;
    this.unit = unit;
  }
}
